import createState from "./state";
import { ImportFieldType } from "../const/field-type";

export const importMutations = {
  setChecksum(state, checksum) {
    state.checksum = checksum;
  },
  setDefaultState(state) {
    // merge to keep observers in place
    Object.assign(state, createState());
  },
  setImportId(state, importId) {
    state.importId = importId;
  },
  setTreatNegativeStatusAsUnknown(state, treatNegativeStatusAsUnknown) {
    state.treatNegativeStatusAsUnknown = treatNegativeStatusAsUnknown;
  },
  setHasNegativeSubscriptionValues(state, hasNegativeSubscriptionValues) {
    state.hasNegativeSubscriptionValues = hasNegativeSubscriptionValues;
  },
  setLastNegativeDetectionMappingHash(state, hash) {
    state.lastNegativeDetectionMappingHash = hash;
  },
  setUploadProgress(state, uploadProgress) {
    state.uploadProgress = uploadProgress;
  },
  setFileToUpload(state, file) {
    state.fileToUpload = file;
  },
  setPreviewRows(state, rows) {
    state.fieldMappings.selectedFields = rows[0] ? new Array(rows[0].length).fill(ImportFieldType.IGNORE) : [];
    state.fieldMappings.previewRows = rows;
  },
  setFieldMapping(state, { colIndex, fieldMapping }) {
    state.fieldMappings.selectedFields[colIndex] = fieldMapping;
  },
  setTags(state, tags) {
    state.tags.importTags = tags;
  },
  setTagsLoading(state, isLoading) {
    state.tags.isLoading = isLoading;
  },
  updateNewTagName(state, tagName) {
    state.tags.newTagName = tagName;
  },
  addTag(state, tag) {
    state.tags.importTags.push(tag);
  },
  updateTagSelection(state, id) {
    const tag = state.tags.importTags.find((t) => t.id === id);
    tag.isSelected = !tag.isSelected;
  },
  setTagsSelection(state, selectedIds) {
    state.tags.importTags.forEach((tag) => {
      tag.isSelected = selectedIds.includes(tag.id);
    });
  },
  setSubscriptionSource(state, source) {
    state.subscriptions.source = source;
  },
  setResurrectDeletedCustomer(state, source) {
    state.resurrectCustomer = source;
  },
  setSubscriptionStatusEmail(state, status) {
    state.subscriptions.email = status;
  },
  setSubscriptionStatusSms(state, status) {
    state.subscriptions.sms = status;
  },
  setSubscriptionStatusWhatsapp(state, status) {
    state.subscriptions.whatsapp = status;
  },
  setDuplicatesAction(state, action) {
    state.duplicates = action;
  },
  setDelimiter(state, delimiter) {
    state.delimiter = delimiter;
  },
  setNoOfRows(state, noOfRows) {
    state.noOfRows = noOfRows;
  },
  setSkipFirstLine(state, skipFirstLine) {
    state.skipFirstLine = skipFirstLine;
  },
  setTagsAction(state, action) {
    state.tags.action = action;
  },
  setImportType(state, type) {
    state.importType = type;
  },
  setImportHistory(state, importHistory) {
    state.importHistory = importHistory.map((entry) => ({
      ...entry,
      isDetailsRowVisible: false,
      statistics: null,
      errors: null,
    }));
  },
  setImportHistoryProgress(state, importHistory) {
    importHistory.forEach((entry) => {
      state.importHistory.find((e) => e.dataImportId === entry.dataImportId).processedRows = entry.processedRows;
      state.importHistory.find((e) => e.dataImportId === entry.dataImportId).status = entry.status;
    });
  },
  setImportStatistics(state, { dataImportId, statistics }) {
    let importHistoryIndex = -1;
    state.importHistory.findIndex((ih, index) => {
      if (ih.dataImportId === dataImportId) {
        importHistoryIndex = index;
      }
    });
    if (importHistoryIndex !== -1) {
      state.importHistory[importHistoryIndex].statistics = statistics;
    }
  },
  setImportErrors(state, { dataImportId, errors }) {
    let importHistoryIndex = -1;
    state.importHistory.findIndex((ih, index) => {
      if (ih.dataImportId === dataImportId) {
        importHistoryIndex = index;
      }
    });
    if (importHistoryIndex !== -1) {
      state.importHistory[importHistoryIndex].errors = errors;
    }
  },
  setImportStatus(state, status) {
    state.importStatus = status;
  },
  setImportPreparing(state, isPreparing) {
    state.importPreparing = isPreparing;
  },
  setMappingPreviewLoading(state, isLoading) {
    state.fieldMappings.isPreviewLoading = isLoading;
  },
  setMappingSuggestionError(state, hasError) {
    state.fieldMappings.hasMappingSuggestionError = hasError;
  },
  setAiProcessed(state, aiProcessed) {
    state.fieldMappings.aiProcessed = aiProcessed;
  },
  setEnableAutoMapping(state, enabled) {
    state.fieldMappings.enableAutoMapping = enabled;
  },
  setValidatedFileChecksum(state, checksum) {
    state.fieldMappings.validatedFileChecksum = checksum;
  },
  setValidatedPreviewRows(state, { rows, validationInfo, suggestedMapping }) {
    state.fieldMappings.previewRows = rows;
    const columnCount = rows.length > 0 ? rows[0].length : 0;

    if (suggestedMapping && suggestedMapping.length > 0) {
      if (suggestedMapping.length < columnCount) {
        const additionalFields = new Array(columnCount - suggestedMapping.length).fill(ImportFieldType.IGNORE);
        state.fieldMappings.selectedFields = [...suggestedMapping, ...additionalFields];
      } else if (suggestedMapping.length > columnCount) {
        state.fieldMappings.selectedFields = suggestedMapping.slice(0, columnCount);
      } else {
        state.fieldMappings.selectedFields = suggestedMapping;
      }
    } else if (columnCount > 0) {
      const currentFieldsLength = state.fieldMappings.selectedFields.length;

      if (currentFieldsLength === 0) {
        state.fieldMappings.selectedFields = new Array(columnCount).fill(ImportFieldType.IGNORE);
      } else if (columnCount !== currentFieldsLength) {
        if (columnCount > currentFieldsLength) {
          const additionalFields = new Array(columnCount - currentFieldsLength).fill(ImportFieldType.IGNORE);
          state.fieldMappings.selectedFields = [...state.fieldMappings.selectedFields, ...additionalFields];
        } else {
          state.fieldMappings.selectedFields = state.fieldMappings.selectedFields.slice(0, columnCount);
        }
      }
    }
    state.fieldMappings.validationInfo = validationInfo;
  },
};
